<template>
  <rabbey-table
    ref="table"
    :headers="headers"
    @get:data="getData"
    :callback-index="callbackIndex"
    index-url="/api/serviceRequests/GetSims"
  />
</template>
<script>
import { getPaginatedItems } from "@/utils";
import RenderCheck from "@/components/functionals/RenderCheck.vue";

export default {
  name: "ReportNavision",
  data() {
    return {
      isMounted: false,
      original: [],
      headers: [
        { name: "IMEI", prop: "IMEI", minWidth: 100 },
        { name: "Telefono", prop: "PHONENUMBER" },
        { name: "Cod. Cliente", prop: "CUSTOMERNO" },
        { name: "Cliente", prop: "CUSTOMERNAME", minWidth: 200 },
        { name: "Serie", prop: "DEVICESERIAL" },
        { name: "Proveedor", prop: "SERVICEPROVIDER" },
        { name: "Cuenta", prop: "SERVICEACCOUNT" },
        { name: "Contrato", prop: "CONTRACTNUMBER" },
        {
          name: "Activo?",
          prop: "ACTIVE",
          formatter: RenderCheck
        }
      ]
    };
  },
  mounted() {
    this.getData();
    this.isMounted = true;
  },
  methods: {
    getPaginatedItems,
    getData() {
      const table = this.$refs.table;

      if (this.isMounted) {
        const { page, pageSize, data } = this.getPaginatedItems(
          this.original,
          table.pagination.currentPage,
          table.pagination.pageSize
        );
        table.pagination.pageSize = pageSize;
        table.pagination.currentPage = page;
        table.items = data;
      } else {
        const config = {
          params: {
            "criteria.companyId": this.currentCompany
          }
        };
        table.indexConfig = config;
        table.getData();
      }
    },
    callbackIndex(resp) {
      const table = this.$refs.table;
      const data = resp.data.ReportD;
      this.original = data;
      table.items = data.slice(0, table.pagination.pageSize);
      table.pagination.total = data.length;
    }
  }
};
</script>

<style></style>
